import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';

export default function ReparationFenetreFrancheville() {
  useEffect(() => {
    document.title = 'Francheville Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Francheville Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Francheville. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Francheville, dépannage fenêtres Francheville, vitrier Francheville');
    }
    
    const linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) {
      linkCanonical.setAttribute('href', 'https://fenetres-lyon.com/reparation-fenetre-francheville');
    }
    
    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '45.7358;4.7644');
    }
    
    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Francheville');
    }
    
    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-69');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CityHero 
        cityName="Francheville"
        imageSeq="francheville-hero-003"
      />
      <Services />
      <Testimonials />
      <Contact />
      <FAQ />
      <Footer />
    </div>
  );
}
